"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canAssign = void 0;
function canAssign() {
    return () => true;
}
exports.canAssign = canAssign;
//# sourceMappingURL=CanAssign.js.map